!function(){
    "use strict";
    const t="[data-section-id]";
    customElements.get("recently-viewed")||
    customElements.define("recently-viewed",
        class extends HTMLElement{constructor(){
            super(),
            this.section=this.closest(t),
            this.howManyToShow=parseInt(this.dataset.limit)||3,
            this.target=this.dataset.target,
            this.wrapperId=this.dataset.wrapperId||
            this.id}connectedCallback(){
                Shopify.Products.showRecentlyViewed(
                    {howManyToShow:this.howManyToShow,
                        wrapperId:this.wrapperId,
                        section:this.section,
                        target:this.target,
                        onComplete:()=>{
                            const wrapper = document.getElementById(this.wrapperId);
                            wrapper.querySelectorAll('.product-card').forEach(card => {
                                const soldOut = card.querySelector('.badge--soldout, .product-card__badge--soldout');
                                const img = card.querySelector('img');
                                if (!img || (soldOut && soldOut.textContent.includes('Sold'))) {
                                card.remove();
                                }
                            });
                            this.dispatchEvent(new CustomEvent("theme:recently-viewed:loaded",{bubbles:!1}))
                        }})}})}();
                        document.addEventListener("theme:recently-viewed:loaded", () => {
  const wrapper = document.querySelector(".recently-viewed, [data-section-type='recently-viewed']");
  if (!wrapper) return;

  wrapper.querySelectorAll(".product-card").forEach(card => {
    const img = card.querySelector("img");
    const soldOutBadge = card.querySelector(".badge--soldout, .product-card__badge--soldout, .product-card__soldout");

    // Hide if there's no image OR if it's clearly marked sold out
    if (!img || !img.getAttribute("src") || (soldOutBadge && soldOutBadge.textContent.toLowerCase().includes("sold"))) {
      card.style.display = "none";
    }
  });
});
